import React, { useCallback, useEffect, useMemo, useState } from 'react';
import styles from './dashboard.module.scss';
import Header from '@src/components/header/Header';
import Footer from '@src/components/footer/Footer';
import {useHistory} from 'react-router-dom';
import Courses from '@src/components/dashboard-courses/Dashboard';
import {UserRoleEnum} from '../../../types';
import Spinner from '@src/components/spinner/Spinner';
import {useIntercom} from 'react-use-intercom';
import { useAnalytics, Events } from '@src/hooks/useAnalytics';
import { useGetAllProgramsLazyQuery } from '@api/graphql-codegen';
import { IntercomCheckListID } from '@constants';
import { useUser } from '@hooks';
import { logger } from '../../../utils/logger';
import FooterPage from '@src/components/footer-page/FooterPage';

function Dashboard() {

  const { boot, isOpen } = useIntercom();
  const history = useHistory();
  const { trackEvent } = useAnalytics();
  const [user] = useUser();
  const [refreshing, setRefreshing] = useState(false)

  const [getAllPrograms, { data: coursesData, loading: coursesLoading}] = useGetAllProgramsLazyQuery({ fetchPolicy: 'network-only' })
  const isSuperAdmin = useMemo(() => user?.role && user.role === UserRoleEnum.SuperAdmin, [user?.role]);
  useEffect(() => {
    getAllPrograms();
  },[getAllPrograms])

  useEffect(() => {
    boot({
      customAttributes: {
        horizontal_padding: 25,
      }
    });
  }, [boot]);
  
  useEffect(() => {
    if ((window as any).Intercom && isOpen) {
      (window as any).Intercom('startChecklist', IntercomCheckListID);
    }
  }, [isOpen]);

  useEffect(() => {
    if (user?.id && !isSuperAdmin) {
      trackEvent(Events.views.dashboard, {
        schoolId: user?.schools?.[0]?.id,
        schoolName: user?.schools?.[0]?.name,
        userId: user?.id,
        userName: `${user?.firstName} ${user?.lastName}`,
      });
    }
  }, [trackEvent, isSuperAdmin, user]);

  const refresh = useCallback(async () => {
    try {
      setRefreshing(true)
      await getAllPrograms({ fetchPolicy: 'network-only' })
    } catch(err) {
      logger.error(err)
    } finally {
      setRefreshing(false)
    }
  }, [getAllPrograms])

  const openSuperUsers = useCallback(() => {
    history.push('/super/users?invite=true');
  }, [history]);

  const openSuperUsersBulk = useCallback(() => {
    history.push('/super/users?bulk-invite=true');
  }, [history]);

  return (
    <>
    <Header inviteUser={openSuperUsers} bulkInvite={openSuperUsersBulk} />
      <div className={styles.page}>
        {(coursesLoading && !refreshing) ? <div className={styles.spinner}><Spinner/></div> : <>
          <Courses courses={coursesData?.programs as any} refresh={refresh} />
        </>}
        <FooterPage />
      </div>
      {/* <Footer/> */}
    </>
  );
}

export default Dashboard;
